import MediaQueryName from '../../data/types/MediaQueryName'
import { StyleBlock } from '../../data/types/StyleBlock'

export default function mapStyles(
  styles: StyleBlock[] | undefined
): Record<MediaQueryName, StyleBlock> {
  return (
    styles?.reduce((total, next) => {
      total[next.mediaQuery] = next
      return total
    }, {} as Record<MediaQueryName, StyleBlock>) ??
    ({} as Record<MediaQueryName, StyleBlock>)
  )
}
